(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  const itemHeading = document.querySelectorAll('.js-heading-item');
  if (itemHeading) {
    itemHeading.forEach(function (item) {
      item.addEventListener('click', function () {
        item.closest('.footer-menu__inner').classList.toggle('active');
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      requestAnimationFrame(() => {
        this.redirectHome()
      });
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

    }

    redirectHome() {
      const logo = this.header.querySelector('.header__heading-link');
      logo.style.pointerEvents = "auto"
      var isHomePage =
          window.location.pathname === '/' ||
          window.location.pathname === '/en' ||
          window.location.pathname === '/en/' ||
          /^\/[a-z]{2}\/?$/i.test(window.location.pathname);

      if (logo && !isHomePage) {
        logo.addEventListener('click', function (e) {
          document.documentElement.classList.add('has-redirect-pending');
          let redirect = localStorage.getItem('rocket_redirect_url');
          const mujerLink = window.themeGenderLinks?.mujer;
          const hombreLink = window.themeGenderLinks?.hombre;

          const fullUrl = window.location.href.toLowerCase();

          if (fullUrl.includes('mujer') && mujerLink) {
            redirect = mujerLink;
          } else if (fullUrl.includes('hombre') && hombreLink) {
            redirect = hombreLink;
          }
          if (!redirect) return;

          e.preventDefault();

          const currentLang = document.documentElement.getAttribute('lang');
          if (currentLang === 'en' && !redirect.startsWith('/en')) {
            redirect = '/en' + redirect;
          }

          window.location.href = redirect;
        });
      }
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      if(document.querySelector('.rocket-scrolling-notice')) {
        document.documentElement.style.setProperty(
        '--header-height-scrolling',
        `${document.querySelector('.rocket-scrolling-notice').offsetHeight}px`
        );
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();

      if(document.querySelector('.rocket-scrolling-notice')) {
        document.documentElement.style.setProperty(
        '--header-scrolling-notice',
        `0px`
        );
      }
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');

      if(document.querySelector('.rocket-scrolling-notice')) {
        document.documentElement.style.setProperty(
        '--header-scrolling-notice',
        `0px`
        );
      }
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');


      if(document.querySelector('.rocket-scrolling-notice')) {
        document.documentElement.style.setProperty(
        '--header-scrolling-notice',
        `${document.querySelector('.rocket-scrolling-notice').offsetHeight}px`
        );
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rocket-shop-the-look"] && !Shopify.designMode) return;
  try {
    
  class DetailsElement {
    constructor(selector) {
      this.detailsList = document.querySelectorAll(selector);
      if (!this.detailsList.length) return;
      this.init();
    }

    init() {
      this.detailsList.forEach((detail) => {
        detail.addEventListener('toggle', () => this.handleToggle(detail));
        const overlay = detail.querySelector('.custom-overlay');
        if (overlay) {
          overlay.addEventListener('click', () => this.closeDetails(detail));
        }
      });

      document.addEventListener('click', this.handleClickOutside.bind(this));

      const modalButtons = document.querySelectorAll('.rocket-popup-modal__button');
      modalButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const modalId = button.closest('.rocket-popup-modal__opener').getAttribute('data-modal');
          const modal = document.querySelector(modalId);
          if (modal) {
            modal.setAttribute('open', '');
            document.body.style.overflow = 'hidden';
          }
        });
      });

      const closeButtons = document.querySelectorAll('.rocket-popup-modal__toggle');
      closeButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const modal = button.closest('.rocket-popup-modal');
          if (modal) {
            modal.removeAttribute('open');
            document.body.style.overflow = '';
            document.body.classList.remove('open-lookbook');
          }
        });
      });
      const modals = document.querySelectorAll('.rocket-popup-modal');
      modals.forEach((modal) => {
        modal.addEventListener('click', (e) => {
          if (e.target === modal) {
            modal.removeAttribute('open');
            document.body.style.overflow = '';
            document.body.classList.remove('open-lookbook');
          }
        });
      });
    }

    handleToggle(activeDetail) {
      if (!activeDetail.open) {
        document.body.classList.remove('open-lookbook');
        return;
      }

      this.detailsList.forEach((detail) => {
        if (detail !== activeDetail && detail.open) {
          detail.removeAttribute('open');
        }
      });

      document.body.classList.add('open-lookbook');

      // Check if dropdown should appear above instead of below
      if (window.innerWidth >= 768) {
        const modal = activeDetail.closest('.rocket-popup-modal__content');
        if (modal) {
          const detailRect = activeDetail.getBoundingClientRect();
          const modalRect = modal.getBoundingClientRect();
          const distanceToBottom = modalRect.bottom - detailRect.bottom;

          // If the detail is in the bottom part of the modal, show dropdown above
          if (distanceToBottom < 200) {
            activeDetail.classList.add('dropdown-top');
          } else {
            activeDetail.classList.remove('dropdown-top');
          }
        }
      }
    }

    handleClickOutside(event) {
      const clickedInside = Array.from(this.detailsList).some((detail) => detail.contains(event.target));

      if (!clickedInside) {
        this.detailsList.forEach((detail) => {
          if (detail.open) {
            detail.removeAttribute('open');
            document.body.classList.remove('open-lookbook');
          }
        });
      }
    }

    closeDetails(detail) {
      detail.removeAttribute('open');
      document.body.classList.remove('open-lookbook');
    }
  }

  new DetailsElement('details.look-book-product__action');

  } catch(e) { console.error(e); }
})();
})();
